/** Compact single-row filter controls for list pages */
export const INLINE_FILTER_FIELD =
  'h-9 min-w-0 rounded-lg border border-gray-300 bg-white py-1.5 px-2.5 text-sm text-gray-900 focus:border-transparent focus:ring-2 focus:ring-primary-500';

export const INLINE_FILTER_BAR =
  'flex flex-wrap items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-2 py-1.5';
